import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { buyers } from "../data/content";
import { images } from "../data/links";
const SHOW_MS = 5000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * buyers.length));
      setMinutes(Math.floor(Math.random() * 12) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), SHOW_MS);
      cycleTimer = window.setTimeout(show, SHOW_MS + GAP_MS);
    };
    const first = window.setTimeout(show, 6000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed inset-x-3 top-3 z-50 sm:inset-x-auto sm:bottom-6 sm:left-6 sm:top-auto" aria-live="polite" data-id="element-40" data-mp="116mhywpkww73">
      <AnimatePresence data-id="element-41" data-mp="1awzc9gn743qf">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${minutes}`} initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl ring-1 ring-navy/10 sm:w-[340px]" data-id="element-42" data-mp="1axhcspgw5445">
            <img src={images.hero} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-paper object-contain" data-id="element-43" data-mp="28jetqifmh1dz" />
            <div className="min-w-0" data-id="element-44" data-mp="23kleakgrz0b6">
              <p className="text-sm font-extrabold text-navy" data-id="element-45" data-mp="23npn5v56qk86">
                {buyer.name} <span className="font-medium text-navy/60" data-id="element-46" data-mp="2aobfes5es8ym">from {buyer.country}</span>
              </p>
              <p className="text-[13px] leading-snug text-navy/80" data-id="element-47" data-mp="2fltgxxh3jlwl">just purchased The ClinCheck Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-ctadark" data-id="element-48" data-mp="2kkoa9tcowsuy">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-49" data-mp="2pjhm7hcbwbt0" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-navy/40 transition-colors duration-150 hover:text-navy" aria-label="Dismiss notification" data-id="element-50" data-mp="1wxy4cgx80e52">
              <XIcon className="h-4 w-4" data-id="element-51" data-mp="196j20o5g1wtt" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}